export default function emailMessage(invoice, {textOnly = false} = {}) {
    function getshipping() {
        if (invoice.shipping) {
            if (!textOnly) {
                return `
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="width: 60%; padding-top: 10px;">Shipping</td>
                    <td style="width: 10%; padding-top: 10px; padding-left:10px; padding-right: 10px; text-align: right;"></td>
                    <td style="width: 30%; padding-top: 10px; text-align: right; white-space: nowrap;">${invoice.shipping}</td>
                  </tr>
                `;
            }
            return `Shipping: ${invoice.shipping}`;
        }
        return '';
    }
    function getAutopay() {
        if (invoice.autopay) {
            if (!textOnly) {
                return `
                <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                  <td style="line-height: 14px;">
                    <br/><span style="font-weight: bold; font-family: Courier, monospace; font-size: 14px;">Autopay Schedule</span><br/>${invoice.autopay}
                  </td>
                </tr>
                `;
            }
            return `Autopay Schedule\n${invoice.autopay}`;
        }
        return '';
    }
    function getInvoiceItems() {
        let items = '';
        invoice.invoiceItems.forEach((item) => {
            if (!textOnly) {
                items += `
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px; vertical-align: baseline;">
                    <td style="padding-top: 10px; padding-bottom: 10px; width: 60%; font-family: Courier, monospace; font-size: 14px; line-height: 14px;">${item.description}<br/><span style="color: #6B7384">${item.period}</span></td>
                    <td style="padding-top: 10px; padding-bottom: 10px; width: 10%; font-family: Courier, monospace; font-size: 14px; padding-left: 10px; padding-right: 10px; text-align: right;">x${item.quantity}</td>
                    <td style="padding-top: 10px; padding-bottom: 10px; width: 30%; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap;">${item.price}</td>
                  </tr>
                `;
            } else {
                const line = [
                    `Description`,
                    `${item.name}`,
                    `${item.description}`,
                    `Qty: x${item.quantity}`,
                    `Price: ${item.price}`,
                    `--------------------------------------------------------------------------\n`,
                ];
                if (item.period) {
                    // add period after description
                    line.splice(3, 0, item.period);
                }
                items += line.join('\n');
            }
        });
        return items;
    }
    function summarizeFinancialActivities(financialActivities) {
        if (financialActivities) {
            let summary = '';
            financialActivities.forEach((financialActivity) => {
                if (!textOnly) {
                    const strikethrough = financialActivity.strikethrough ? 'text-decoration: line-through;' : '';
                    summary += `
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px; vertical-align: baseline;">
                    <td style="width: 60%; padding-top: 10px; padding-bottom: 10px; font-family: Courier, monospace; font-size: 14px; line-height: 14px;">${financialActivity.description}</td>
                    <td style="width: 10%; padding-top: 10px; padding-bottom: 10px; font-family: Courier, monospace; font-size: 14px; padding-left:10px; padding-right: 10px; text-align: right;"></td>
                    <td style="width: 30%; padding-top: 10px; padding-bottom: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap; ${strikethrough}">${financialActivity.amount}</td>
                  </tr>
                `;
                } else {
                    summary += `${financialActivity.description}: ${financialActivity.amount}\n`;
                }
            });
            return summary;
        }
        return '';
    }
    function getAddress(address) {
        let processAddress = '';
        const items = Object.values(address)
            .map(item => (Array.isArray(item) ? item.join(' ').trim() : item))
            .filter(Boolean);
        items.forEach((item) => {
            if (!textOnly) {
                processAddress += `${item}<br/>`;
            } else {
                processAddress += `${item}\n`;
            }
        });
        return processAddress;
    }
    if (!textOnly) {
        return `
        <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
        <html xmlns="http://www.w3.org/1999/xhtml">
        
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
          <title>${invoice.invoiceId}</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </head>
        
        <body style="margin: 0; padding: 0; width: 100%; max-width: 520px;">
          <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%">
            <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
              <td style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px; border-bottom: 1px solid #0D2B3E; padding-bottom: 10px;">
                Invoice ${invoice.invoiceNumber}<br/> ${invoice.invoiceStatus}
              </td>
            </tr>
            <tr>
              <td style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px; padding-top: 10px;">
                Customer Id: ${invoice.invoiceCustomerId}
                <br/>PO Number: ${invoice.invoicePO || '—'}
                <br/>Issue Date: ${invoice.invoiceIssueDate}
                <br/>Due Date: ${invoice.invoiceDueDate}
                <br/><br/>
                <span style="font-weight: bold;">Billed to</span><br/>${getAddress(invoice.billedTo)}
                <br/>
                <br/>
                <span style="font-weight: bold;">Delivered to</span><br/>${getAddress(invoice.deliveredTo)}
                <br/>
              </td>
            </tr>
            <tr>
              <td>
                <br/>
                <table align="left" border="0" cellpadding="0" cellspacing="0" width="100%">
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="border-bottom: 1px solid #0D2B3E; padding-bottom: 10px; width: 60%; font-family: Courier, monospace; font-size: 14px; font-weight: bold;">Description</td>
                    <td style="border-bottom: 1px solid #0D2B3E; padding-bottom: 10px; padding-left:10px; padding-right: 10px; width: 10%; font-family: Courier, monospace; font-size: 14px; text-align: right; font-weight: bold;">Qty</td>
                    <td style="border-bottom: 1px solid #0D2B3E; padding-bottom: 10px; width: 30%; text-align: right; font-family: Courier, monospace; font-size: 14px; font-weight: bold;">Price</td>
                  </tr>
                  ${getInvoiceItems()}
                  <tr>
                    <td style="border-bottom: 1px solid #0D2B3E;">
                    </td>
                    <td style="border-bottom: 1px solid #0D2B3E;">
                    </td>
                    <td style="border-bottom: 1px solid #0D2B3E;">
                    </td>
                  </tr>
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="width: 60%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px;">Subtotal</td>
                    <td style="width: 10%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; padding-left:10px; padding-right: 10px; text-align: right;"></td>
                    <td style="width: 30%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap;">${invoice.subtotal}</td>
                  </tr>
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="width: 60%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px;">Discounts</td>
                    <td style="width: 10%; padding-top: 10px; padding-left:10px; padding-right: 10px; text-align: right; font-family: Courier, monospace; font-size: 14px;"></td>
                    <td style="width: 30%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap;">${invoice.discounts}</td>
                  </tr>
                  ${getshipping()}
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="width: 60%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px;">Taxes</td>
                    <td style="width: 10%; padding-top: 10px; padding-left:10px; padding-right: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right;"></td>
                    <td style="width: 30%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap;">${invoice.taxes}</td>
                  </tr>
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="width: 60%; padding-top: 10px; padding-bottom: 10px; font-family: Courier, monospace; font-size: 14px;">Total</td>
                    <td style="width: 10%; padding-top: 10px; padding-bottom: 10px; padding-left:10px; padding-right: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right;"></td>
                    <td style=" width: 30%; padding-top: 10px; padding-bottom: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap;">${invoice.total}</td>
                  </tr>
                  ${summarizeFinancialActivities(invoice.transactionItems)}
                  ${summarizeFinancialActivities(invoice.creditMemoItems)}
                  <tr>
                    <td style="border-bottom: 1px solid #0D2B3E;">
                    </td>
                    <td style="border-bottom: 1px solid #0D2B3E;">
                    </td>
                    <td style="border-bottom: 1px solid #0D2B3E;">
                    </td>
                  </tr>
                  <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
                    <td style="width: 60%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; font-weight: bold;">Amount Due</td>
                    <td style="width: 10%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; padding-left:10px; padding-right: 10px; text-align: right;"></td>
                    <td style=" width: 30%; padding-top: 10px; font-family: Courier, monospace; font-size: 14px; text-align: right; white-space: nowrap;">${invoice.amountDue}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr style="color: #0D2B3E; font-family: Courier, monospace; font-size: 14px;">
              <td style="line-height: 14px; font-family: Courier, monospace; font-size: 14px;">
                <br/><br/><span style="font-weight: bold;">Notes</span><br/>${invoice.notes || '—'}
              </td>
            </tr>
            ${getAutopay()}
          </table>
        </body>
        </html>`;
    }
    return `${invoice.invoiceNumber}
${invoice.invoiceStatus}
--------------------------------------------------------------------------
Customer ID: ${invoice.customerId}
${invoice.invoiceId}
PO Number: ${invoice.invoicePO || '—'}
Due Date: ${invoice.invoiceDueDate}
Issue Date: ${invoice.invoiceIssueDate}

Billed To
${getAddress(invoice.billedTo)}
Delivered To
${getAddress(invoice.deliveredTo)}
--------------------------------------------------------------------------
${getInvoiceItems()}Subtotal: ${invoice.subtotal}
Discounts: ${invoice.discounts}
${getshipping()}
Taxes: ${invoice.taxes}
Total: ${invoice.total}
${summarizeFinancialActivities(invoice.transactionItems)}
${summarizeFinancialActivities(invoice.creditMemoItems)}
--------------------------------------------------------------------------
Amount Due: ${invoice.amountDue}
--------------------------------------------------------------------------
Notes:
${invoice.notes || '—'}

${getAutopay()}`;
}
